<p-toast position="bottom-right"></p-toast>
<p-panel header="Attachments">
  <ng-template pTemplate="icons">

    @if (displayAttachments().length > 0) {
      <button pButton type="button" icon="pi pi-trash" iconPos="left" class="p-button-danger p-button-icon-only mr-1" (click)="onRemoveToggle()"></button>
    }
    <p-fileUpload #uploadComponent class="inline-block" name="images[]" mode="basic" [auto]="true" [multiple]="true" accept="image/*,.pdf"
      [url]="uploadUrl()" [maxFileSize]="10000000" (onUpload)="onUpload($event)" (onProgress)="onProgress($event)" (onSend)="onSend($event)" (onError)="onUploadError($event)">
      <ng-template pTemplate="content">
        @if (uploadedFiles().length) {
          <ul>
            @for (file of uploadedFiles(); track file) {
              <li>{{file.name}} - {{file.size}} bytes</li>
            }
          </ul>
        }
      </ng-template>
    </p-fileUpload>
  </ng-template>
  @if (uploading()) {
    <p-progressBar [value]="uploadProgress()"></p-progressBar>
  }

  <div class="flex flex-row flex-wrap">
    @for (attachment of displayAttachments(); track attachment.displayUrl) {
      <div>
        <div class="flex flex-col inline-block mx-2 mb-2 relative">

          @if (attachment.attachment.mime.startsWith('image/')) {
            <p-image #image
              class="mx-auto" [src]="attachment.displayUrl" [preview]="true" height="130"
            (onShow)="showPreview(attachment, image)"></p-image>
          }

          <a [href]="attachment.displayUrl" target="_blank"  class="mx-auto">@if (attachment.attachment.mime.startsWith('application/pdf')) {
            <img
              src="assets/pdf-thumbnail.png" height="130">
            }</a>



            @if (removeActive()) {
              <div class="flex flex-row-reverse absolute top-0 w-full">
                <button pButton type="button" class="p-button-sm p-button-danger" (click)="removeAttachment(attachment)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            }
            <i  class="text-center">{{attachment.attachment.originalFilename}}</i>
            <i class="text-center">Uploaded by {{attachment.attachment.staff.first}} {{attachment.attachment.staff.last}} on
            {{attachment.attachment.dateAttached | date:'shortDate'}}</i>
          </div>
        </div>
      }
    </div>

  </p-panel>
